export default __webpack_public_path__ + "static/media/app_logo.90bf606e.png";